/**
 * Адрес бэкенда.
 *
 * По умолчанию — свой же домен: nginx отдаёт и приложение, и `/api` с одного
 * хоста, поэтому адрес можно не называть вовсе. Так сборка перестаёт зависеть
 * от того, на каком домене её потом откроют, — при переезде на поддомен
 * пересобирать нечего.
 *
 * Переменная REACT_APP_BACKEND_URL нужна только для разработки, когда фронт
 * крутится на одном порту, а бэкенд на другом. Она же однажды подвела: сборку
 * с локальным `http://localhost:8001` выложили на прод, и живые запросы ушли
 * в никуда. Отсюда и правило — пусто значит «свой домен», а не «сломано».
 */
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

/** Полный адрес метода: apiUrl('/api/files') → '/api/files' или 'http://localhost:8001/api/files'. */
export function apiUrl(path) {
  return `${BACKEND_URL}${path}`;
}
